// ============================================================================
// MAPA DE TOKENS — identidad visual del sitio
// Fuente de verdad: el sistema de diseño de la referencia (kimi.page).
//
// Estos tokens sobreviven porque las dos secciones que NO vienen de la
// referencia —conocimiento con artículos reales y biblioteca de ebooks— y la
// vista de artículo siguen escritas con estilos inline. Todo lo que sí viene de
// la referencia usa las clases de Tailwind de sus componentes.
//
//   ink / navy   #0F1419   fondo oscuro (secciones) y también texto/heading
//                          sobre fondo claro: casi negro, sirve a los dos roles.
//   inkDeep      #0A0E14   fondo aún más oscuro (footer profundo).
//   cream        #F5F0E8   fondo de sección clara; también texto sobre oscuro
//                          (15-16:1 de contraste).
//   creamText    #F0EBE2   texto sobre fondo oscuro.
//   gold         #C9A26E   acento de marca. Legible sobre fondos OSCUROS
//                          (7.83:1). NO como TEXTO sobre fondos claros
//                          (2.09-2.37:1, incumple AA) -> usar goldText.
//   goldText     #8C6634   dorado oscurecido para TEXTO sobre fondo CLARO:
//                          5.17:1 sobre blanco, 4.55:1 sobre cream. Cumple AA.
//   textDark     #1A1A1A   texto de cuerpo sobre fondo claro.
//   textLight    #6E685F   texto secundario sobre fondo claro: 5.51:1 / 4.86:1.
//   mutedLight   #A09888   texto secundario sobre fondo OSCURO: 6.47:1.
//   muted        #8A8075   texto terciario sobre fondo oscuro: 4.78:1.
//   mutedDeep    #5A544C   texto muy apagado sobre oscuro, decorativo.
//   border       #E1D8C8   borde sutil sobre fondo claro.
//   error        #C62828   texto/borde de error sobre claro: 5.62:1 / 4.96:1.
// ============================================================================
export const COLORS = {
  // Fondos oscuros
  navy: "#0F1419",
  ink: "#0F1419",
  inkDeep: "#0A0E14",

  // Fondos claros
  cream: "#F5F0E8",
  creamText: "#F0EBE2",
  white: "#FFFFFF",

  // Acento dorado
  copper: "#C9A26E",
  gold: "#C9A26E",
  copperText: "#8C6634",
  goldText: "#8C6634",

  // Texto
  text: "#1A1A1A",
  textDark: "#1A1A1A",
  textLight: "#6E685F",
  mutedLight: "#A09888",
  muted: "#8A8075",
  mutedDeep: "#5A544C",

  // Bordes / estado
  border: "#E1D8C8",
  error: "#C62828",
};
